import { useContext, useCallback, useEffect } from 'react';
import { LiveChatLoaderContext } from "../context";
import * as Providers from "../providers";
var requestIdleCallback = typeof window !== 'undefined' ? window.requestIdleCallback : null;
var connection = typeof window !== 'undefined' ?
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.navigator && window.navigator.connection : null;
var useChat = function useChat() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      loadWhenIdle: false
    },
    loadWhenIdle = _ref.loadWhenIdle;
  var _useContext = useContext(LiveChatLoaderContext),
    provider = _useContext.provider,
    providerKey = _useContext.providerKey,
    idlePeriod = _useContext.idlePeriod,
    state = _useContext.state,
    setState = _useContext.setState,
    appID = _useContext.appID,
    locale = _useContext.locale,
    baseUrl = _useContext.baseUrl,
    instanceId = _useContext.instanceId,
    env = _useContext.env,
    geo = _useContext.geo,
    beforeInit = _useContext.beforeInit,
    onReady = _useContext.onReady;
  useEffect(function () {
    // Don't load if idlePeriod is 0, null or undefined
    if (typeof window === 'undefined' || !loadWhenIdle || !idlePeriod) return;

    // Don't load if 2g connection or save-data is enabled
    if (connection && (connection.saveData || /2g/.test(connection.effectiveType))) return;
    if (isNaN(idlePeriod)) return;

    // deadline.timeRemaining() has an upper limit of 50 milliseconds
    // We want to ensure the page has been idle for a significant period of time
    // Therefore we count consecutive maximum timeRemaining counts and load chat when we reach our threshold
    var elapsedIdlePeriod = 0;
    var previousTimeRemaining = 0;
    var _scheduleLoadChat = function scheduleLoadChat(deadline) {
      if (elapsedIdlePeriod > idlePeriod) return loadChat({
        open: false
      });
      var timeRemaining = deadline.timeRemaining();
      // To ensure browser is idle, only accumalte elapsedIdlePeriod when
      // two consecutive maximum timeRemaining's have been observed
      if (previousTimeRemaining > 49 && timeRemaining > 49) elapsedIdlePeriod += timeRemaining;
      previousTimeRemaining = timeRemaining;
      requestIdleCallback === null || requestIdleCallback === void 0 || requestIdleCallback(_scheduleLoadChat);
    };
    if (requestIdleCallback) {
      requestIdleCallback(_scheduleLoadChat);
    } else {
      setTimeout(function () {
        return loadChat({
          open: false
        });
      }, idlePeriod);
    }
  }, []);
  var chatProvider = Providers[provider];
  var loadChat = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        open: true
      },
      _ref2$open = _ref2.open,
      open = _ref2$open === void 0 ? true : _ref2$open;
    if (!providerKey) {
      //eslint-disable-next-line no-console
      console.error('No api key given to react-live-chat-loader');
      return;
    }
    if (!provider) {
      //eslint-disable-next-line no-console
      console.error('No provider given to react-live-chat-loader');
      return;
    }
    chatProvider.load({
      providerKey: providerKey,
      setState: setState,
      appID: appID,
      locale: locale,
      baseUrl: baseUrl,
      instanceId: instanceId,
      env: env,
      geo: geo,
      beforeInit: beforeInit,
      onReady: onReady
    });
    if (open) {
      chatProvider.open();
      if (state !== 'complete') setState('open');
    }
  }, [state]);
  return [state, loadChat];
};
export default useChat;